import * as React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Grid } from '@mui/material';

export default function ListItemReviewedNotes(
    props: ListProps
): React.ReactElement {
    const {
        TitleNotes,
        ToRework,
        NotApplicable,
        DocMissing,
        Escalated,
        Correct,
        // PaperDoc,
        // Handsign,
        // Notverifiedsign,
    } = props;
    return (
        <ListItem className="reviewed-item">
            <Grid container spacing={2} className="reviewed-item-container">
                <Grid item xs={12} md={5} className="content-list">
                    <ListItemText
                        primary={TitleNotes}
                        className="content-list-primary-description"
                    />
                </Grid>
                <Grid
                    container
                    item
                    xs={12}
                    md={7}
                    className="content-check-reviewed-list"
                >
                    <Grid item xs={12} md={3} className="item-content-list">
                        <ListItemText
                            classes={{
                                secondary: 'secondary-content',
                                root: 'root-content',
                            }}
                            secondary="Send to Rework"
                            className={ToRework ? 'selected' : 'not-selected'}
                        />
                    </Grid>
                    <Grid item xs={12} md={2} className="item-content-list">
                        <ListItemText
                            classes={{
                                secondary: 'secondary-content',
                                root: 'root-content',
                            }}
                            secondary="Not Applicable"
                            className={
                                NotApplicable ? 'selected' : 'not-selected'
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={2} className="item-content-list">
                        <ListItemText
                            classes={{
                                secondary: 'secondary-content',
                                root: 'root-content',
                            }}
                            secondary="Document Missing"
                            className={DocMissing ? 'selected' : 'not-selected'}
                        />
                    </Grid>
                    {/* <Grid item xs={12} md={2} className="item-content-list">
                        <ListItemText
                            classes={{
                                secondary: 'secondary-content',
                                root: 'root-content',
                            }}
                            secondary="Paper Document"
                            className={PaperDoc ? 'selected' : 'not-selected'}
                        />
                    </Grid> */}
                    <Grid item xs={12} md={3} className="item-content-list">
                        <ListItemText
                            secondary="Escalated to a Admin"
                            classes={{
                                secondary: 'secondary-content',
                                root: 'root-content',
                            }}
                            className={Escalated ? 'selected' : 'not-selected'}
                        />
                    </Grid>
                    <Grid item xs={12} md={2} className="item-content-list">
                        <ListItemText
                            classes={{
                                secondary: 'secondary-content',
                                root: 'root-content',
                            }}
                            secondary="Marked as correct"
                            className={Correct ? 'selected' : 'not-selected'}
                        />
                    </Grid>
                    {/* <Grid item xs={12} md={1} className="item-content-list">
                        <ListItemText
                            classes={{
                                secondary: 'secondary-content',
                                root: 'root-content',
                            }}
                            secondary="Hand signed"
                            className={Handsign ? 'selected' : 'not-selected'}
                        />
                    </Grid> */}
                    {/* <Grid item xs={12} md={2} className="item-content-list">
                        <ListItemText
                            classes={{
                                secondary: 'secondary-content',
                                root: 'root-content',
                            }}
                            secondary="Sign Not Verified"
                            className={
                                Notverifiedsign ? 'selected' : 'not-selected'
                            }
                        />
                    </Grid> */}
                </Grid>
            </Grid>
        </ListItem>
    );
}
